module.exports = __webpack_public_path__ + "img/reply-fill.2fb8524e.svg";